// import React from "react";
// import { Modal, Box, Typography, Button } from "@mui/material";

// const PDFmodal = ({ isOpen, onClose, pdfUrl }) => {
//   return (
//     <Modal open={isOpen} onClose={onClose} aria-labelledby="pdf-modal-title">
//       <Box
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: "80vw",
//           height: "80vh",
//           bgcolor: "background.paper",
//           boxShadow: 24,
//           p: 2,
//           borderRadius: 2,
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <Typography id="pdf-modal-title" variant="h6" component="h2">
//           PDF Viewer
//         </Typography>

//         {/* PDF Viewer */}
//         {/* <Box sx={{ flex: 1, overflow: "hidden", mt: 2 }}>
//           <iframe
//             src={pdfUrl}
//             title="PDF Viewer"
//             width="100%"
//             height="100%"
//             style={{ border: "none" }}
//           />
//         </Box> */}
//         <Box sx={{ flex: 1, overflow: "hidden", mt: 2 }}>
//           <embed
//             src={pdfUrl}
//             type="application/pdf"
//             width="100%"
//             height="100%"
//           />
//         </Box>

//         {/* Buttons */}
//         <Box mt={2} display="flex" justifyContent="space-between">
//           <Button variant="contained" color="primary" href={pdfUrl} download>
//             Download PDF
//           </Button>
//           <Button variant="contained" color="error" onClick={onClose}>
//             Close
//           </Button>
//         </Box>
//       </Box>
//     </Modal>
//   );
// };

// export default PDFmodal;

import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { esignURL } from "../utilities/ApiConfig";

const PDFmodal = ({ isOpen, onClose, pdfUrl, emailsendpdf }) => {
  const [checked, setChecked] = useState(false);
  const [emailsend, setIsemailsend] = useState(false);

  const pdfDataUrl = `data:application/pdf;base64,${pdfUrl}`;
  const pde = "UKPDE2024010100230";
  const handleSendClick = async () => {
    const payload = {
      EmpLeaveRec1: {
        API_type: "srotype29aug",
        Client: "sroclient29aug",
        Parameter: `${pde}`,
        DocName: `${pde}.pdf`,
        PDE_ID: pde,
      },
    };

    try {
      const response = await axios.post(
        // "https://localhost:44369/Home/uploadpdf", // Ensure this endpoint is correct and accessible
        `${esignURL}/Home/uploadpdf`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status < 200 || response.status >= 300) {
        throw new Error("Failed to send data");
      }
      debugger;
      if (response.status === 200) {
        debugger;
        // Ensure emailsendpdf is a function before calling it
        if (typeof emailsendpdf === "function") {
          emailsendpdf(true);
        }
        onClose();
      }
      return response.data;
    } catch (error) {
      // Log additional details for debugging
      if (error.response) {
        console.error("Server responded with a status:", error.response.status);
        console.error("Response data:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
      console.error("Error sending email link:", error);
      throw error;
    }
  };
  return (
    <Modal open={isOpen} onClose={onClose} aria-labelledby="pdf-modal-title">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80vw",
          height: "80vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Close Button */}
        <IconButton
          sx={{ position: "absolute", top: 10, right: 10 }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <Typography id="pdf-modal-title" variant="h6" component="h2">
          PDF Viewer
        </Typography>

        {/* PDF Viewer */}
        {/* <Box sx={{ flex: 1, overflow: "hidden", mt: 2 }}>
          <iframe
            src={pdfUrl}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </Box> */}

        {/* working for pdf opened through Url */}
        {/* start */}
        {/* <Box sx={{ flex: 1, overflow: "hidden", mt: 2 }}>
          <embed
            src={pdfUrl}
            type="application/pdf"
            width="100%"
            height="100%"
          />
        </Box> */}
        {/* end */}

        {/* PDF Viewer with Base64 */}
        <Box sx={{ flex: 1, overflow: "hidden", mt: 2 }}>
          <embed
            src={pdfDataUrl}
            type="application/pdf"
            width="100%"
            height="100%"
          />
        </Box>

        {/* Buttons */}
        {/* <Box mt={2} display="flex" justifyContent="center">
          <Button variant="contained" color="primary" href={pdfUrl} download>
            Proceed & send e-sign link to parties
          </Button>
        </Box> */}

        <Box mt={2} display="flex" flexDirection="column" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
                color="primary"
              />
            }
            label="I agree to the terms and conditions"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSendClick}
            download
            disabled={!checked} // Disable button if checkbox is not checked
          >
            Proceed & send e-sign link to parties
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PDFmodal;
